<template>
  <div class="image-picker" :class="{'disabled-input': disabled}">
    <v-tooltip bottom v-if="!tempUrl">
      <template v-slot:activator="{ on }">
        <v-btn class="preview" @click="showPicker" text v-on="on" style="margin-bottom: 10px;">
          <v-icon v-text="'mdi-plus'"></v-icon>
        </v-btn>
      </template>
      <span>{{tooltip || "Image"}}</span>
    </v-tooltip>
    <img class="image" v-if="tempUrl" :src="tempUrl" @click="showPicker" />
    <v-icon class="remove-icon" x-small color="red" v-if="tempUrl" @click="removeUrl()">mdi-close</v-icon>
    <v-dialog
      :close-on-content-click="false"
      :close-on-click="true"
      v-model="visible"
      width="900px"
      scrollable
    >
      <v-card style="height: 600px">
        <div class="d-flex">
          <v-btn
            text
            :color="selectedMode === 'LIBRARY' ? 'primary' : ''"
            @click="selectedMode='LIBRARY'"
            v-if="modes.indexOf('LIBRARY') > -1"
          >Library</v-btn>
          <v-btn
            text
            :color="selectedMode === 'UPLOAD' ? 'primary' : ''"
            @click="selectedMode='UPLOAD'"
            v-if="modes.indexOf('UPLOAD') > -1"
          >Upload</v-btn>
          <v-spacer></v-spacer>
          <v-icon small @click="visible = false" class="mr-2">mdi-close</v-icon>
        </div>
        <v-divider></v-divider>
        <ImagePickerLibrary
          @input="tempUrl = $event; $emit('input', $event)"
          v-if="selectedMode==='LIBRARY'"
          :url="tempUrl"
        ></ImagePickerLibrary>
        <ImagePickerUpload
          @input="tempUrl = $event; $emit('input', $event)"
          @close="visible = false"
          v-if="selectedMode==='UPLOAD'"
        ></ImagePickerUpload>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ImagePickerLibrary from "./ImagePickerLibrary";
import ImagePickerUpload from "./ImagePickerUpload";

export default {
  components: {
    ImagePickerLibrary,
    ImagePickerUpload
  },
  data() {
    return {
      visible: false,
      x: 0,
      y: 0,
      tempUrl: "",
      selectedMode: this.defaultMode // LIBRARY | UPLOAD
    };
  },
  props: ["url", "defaultMode", "modes", "tooltip", "disabled"],
  methods: {
    showPicker(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    removeUrl() {
      this.tempUrl = "";
      this.$emit("input", this.tempUrl);
    }
  },
  created() {
    this.tempUrl = this.url;
  },
  updated() {
    this.tempUrl = this.url;
  }
};
</script>

<style scoped>
.image-picker {
  position: relative;
  width: 70px;
}
.preview {
  width: 70px;
  height: 70px !important;
  border-radius: 3px;
  border: 1px solid #cccccc;
  background: #efefef;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
}
.image {
  width: 100%;
  max-height: 220px;
  border-radius: 3px;
  border: 1px solid #cccccc;
  background: #efefef;
  box-sizing: border-box;
  outline: none;
  -webkit-appearance: none;
  background-size: contain;
  cursor: pointer;
}
.remove-icon {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
  background-color: white;
}
</style>